import { useEffect } from "react";
import { selectErrorCode, setErrorCode } from "./ErrorHandlerSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ErrorHandler = () => {
  const errorCode = useSelector(selectErrorCode);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (errorCode == null) return;

    navigate(`/error/${errorCode}`);
    dispatch(setErrorCode(null));
  }, [dispatch, errorCode, navigate]);

  return <></>;
};

export default ErrorHandler;
